import { Component, OnDestroy, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { SchaltleitungService } from '../../service/schaltleitung/schaltleitung.service';
import { Router } from '@angular/router';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { MatTableDataSource } from '@angular/material/table';
import { take, takeWhile } from 'rxjs/operators';
import { SettingsSchaltleitungDetailComponent } from '../settings-schaltleitung-detail/settings-schaltleitung-detail.component';
import { Schaltleitung } from '../../domain/model/schaltleitung';

@Component({
    selector: 'tnb-settings-schaltleitungen',
    templateUrl: './settings-schaltleitungen-page.component.html',
    styleUrls: [
        './settings-schaltleitungen-page.component.scss',
    ],
    standalone: false,
})
export class SettingsSchaltleitungenPageComponent implements OnInit, OnDestroy {
    private schaltleitungService = inject(SchaltleitungService);
    private router = inject(Router);
    private westnetzSidenavService = inject(WestnetzSidenavService);
    private changeDetectorRef = inject(ChangeDetectorRef);

    public schaltleitungenList = new MatTableDataSource<Schaltleitung>();
    public componentDestroyed = false;

    public columnsToDisplay = [
        'kuerzel',
        'name',
        'email',
        'adresse',
        'kontakte',
    ];

    ngOnInit() {
        this.reloadSchaltleitungen();
        this.westnetzSidenavService.closeRightnav$
            .pipe(takeWhile(() => !this.componentDestroyed))
            .subscribe(() => {
                this.reloadSchaltleitungen();
            });
    }

    private reloadSchaltleitungen() {
        this.schaltleitungService.getSchaltleitungen()
            .pipe(take(1))
            .subscribe(kb => {
                this.schaltleitungenList.data = kb;
                this.changeDetectorRef.markForCheck();
            });
    }

    public createSchaltleitung() {
        this.router.navigate([],
            {
                queryParams: { schaltleitung: '' },
                queryParamsHandling: 'merge',
                skipLocationChange: true,
            });
        this.westnetzSidenavService.openRightnav(SettingsSchaltleitungDetailComponent);
    }

    openSchaltleitung(schaltleitung: Schaltleitung) {
        this.router.navigate([],
            {
                queryParams: { schaltleitung: schaltleitung.id },
                queryParamsHandling: 'merge',
                skipLocationChange: true,
            });
        this.westnetzSidenavService.openRightnav(SettingsSchaltleitungDetailComponent);

    }

    ngOnDestroy(): void {
        this.componentDestroyed = true;
    }
}
